import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const documentaryResourceArchive = createApiThunk<void, string>(
  "documentaryResource/archive",
  async (resourceId: string, { extra: { adminRepository } }) => {
    return adminRepository!.archiveDocumentaryResource(resourceId);
  },
);

export const documentaryResourceArchiveReset = createAction("documentaryResource/archiveReset");
